import { render } from "./warningSetting.vue?vue&type=template&id=1f36942c&scoped=true"
import script from "./warningSetting.vue?vue&type=script&lang=js"
export * from "./warningSetting.vue?vue&type=script&lang=js"

import "./warningSetting.vue?vue&type=style&index=0&id=1f36942c&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f36942c"]])

export default __exports__